"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMPTY_CHECKBOX_OPTIONS = void 0;
var EMPTY_CHECKBOX_OPTIONS = exports.EMPTY_CHECKBOX_OPTIONS = {
  values: [],
  labels: []
};